/* eslint-disable default-case */
import React, { memo, useEffect, useState } from 'react';
import * as excelJs from 'exceljs';
import { CloudUpload, ExitToApp } from '@mui/icons-material';
import { Backdrop, Button, CircularProgress, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import dayjs from 'dayjs';
import { useFetchOpeningBalanceDateQuery } from '../../../redux/apis/openingbalacedate.api';
import { useExportModal } from '../../../features/Exports/hooks/useExportModal';
import ExportModal from '../../../features/Exports/components/ExportModal';
import { useSelector } from 'react-redux';
// import ExportModaluseExportModal from '../../../features/Exports/components/ExportModal';
function DbExportButton({
  dbItem,
  accounttypeflag,
  dashboardVariables,
  hideZeroBalance,
  hideGroupTotal,
  company,
  range,
  financialyearid,
  selectedTab,
  endDate,
  startDate,
  isDashboard = false,
  onDashboardExport,
  includeOpeningBalance,
  selectedAccount,
  onExportClick,
  getSetoffValues,
}) {
  console.log(accounttypeflag, 'accounttypeflag');

  const tab = Number(selectedTab);

  const [loading, setLoading] = useState(false);
  const selectedInventoryItem = useSelector((state) => state?.inventoryItemSelectionReducer?.selectedItem);
  const [startExportDate, setStartExportDate] = useState('');
  const { exportModalProps, ExportLedgers, ExportItemwiseStockLedger, ExportStockLedger, ExportTCS } = useExportModal();
  const { data: openingBalanceDate, isLoading } = useFetchOpeningBalanceDateQuery(
    {
      invoicetypecd: 'Sales',
      invoiceid: 0,
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );
  const navigate = useNavigate();
  const obDate = dayjs(openingBalanceDate?.getMinMaxInvoiceDate?.openingbalancedate).unix();
  useEffect(() => {
    if (startDate > obDate) {
      setStartExportDate(startDate);
    } else {
      setStartExportDate(obDate);
    }
  }, [obDate, startDate]);

  const routeSelector = (selectedTab) => {
    switch (Number(selectedTab)) {
      case 1:
        return `/exports/ledgers?startDate=${startDate}&endDate=${endDate}`;
      case 2:
        return `/exports/ledgers?startDate=${startDate}&endDate=${endDate}`;
      case 3:
        return `/exports/ledgers?startDate=${startDate}&endDate=${endDate}`;
      case 4:
        return `/exports/tcs?startDate=${startDate}&endDate=${endDate}&option=TCSREC`;
      case 5:
        return `/exports/tds?startDate=${startDate}&endDate=${endDate}&option=TDSREC`;
      default:
        return `/exports/default?startDate=${startDate}&endDate=${endDate}`;
    }
  };

  const handleDashboardExport = () => {
    if (onDashboardExport) {
      onDashboardExport();
    }
  };
  function sanitizeWorksheetName(name) {
    if (typeof name !== 'string') return 'Sheet';

    // Invalid characters for Excel worksheet names
    const invalidChars = /[\\\/\?\*\[\]\:]/g;

    // Replace invalid characters with space
    let clean = name.replace(invalidChars, ' ');

    // Collapse multiple spaces to a single space
    clean = clean.replace(/\s+/g, ' ').trim();

    clean = clean.replace(/^'+|'+$/g, '');

    return clean;
  }

  const handleLedgerExport = () => {
    if (tab === 1 || tab === 2 || tab === 3) {
      // Get setoff values only when export is triggered (no performance impact)
      const setoffValues = getSetoffValues ? getSetoffValues() : {};
      const hasValidValue = selectedAccount.some((obj) => Number(obj.accounttypeflag) === 1 || Number(obj.accounttypeflag) === 2);
      ExportLedgers({
        ledgerOptions: {
          openingBalance: includeOpeningBalance === true ? 1 : 0,
          AccountDetails: selectedAccount.map((acc, i) => ({
            accountId: acc.accountsid,
            worksheetName: i + 1 + '. ' + sanitizeWorksheetName(acc.accountname),
            setoff: hasValidValue,
          })),
        },
        accounttypeflag: accounttypeflag === true ? 1 : null,
        startDate: startDate || null,
        endDate: endDate || null,
        setoffValues: hasValidValue,
      });
    } else if (tab === 9) {
      if (selectedAccount?.[0]?.accountsid === '101') {
        ExportItemwiseStockLedger({
          startDate: startDate || null,
          endDate: endDate || null,
          options: {
            openingBalance: includeOpeningBalance === true ? 1 : 0,
          },
        });
      } else {
        ExportStockLedger({
          startDate: startDate || null,
          endDate: endDate || null,
          options: {
            itemId: selectedInventoryItem?.itemid,
            openingBalance: includeOpeningBalance === true ? 1 : 0,
            ItemName: selectedInventoryItem?.itemname,
            Unit: selectedInventoryItem?.unit,
            itemCode: selectedInventoryItem?.itemcode,
          },
        });
      }
    } else if (tab === 5) {
      // Open TCS export modal (instead of navigating)
      ExportTCS({
        tdstcsoption: 'TCSREC',
        startDate: startDate || null,
        endDate: endDate || null,
      });
    } else {
      navigate(routeSelector(selectedTab));
    }
  };

  return (
    <>
      {tab === 4 || tab === 5 || tab === 1 || tab === 2 || tab === 3 || tab === 9 ? (
        <Tooltip title="Export" placement="bottom">
          <Button
            disableRipple
            disableElevation
            variant="outlined"
            sx={{
              color: 'primary.main',
              backgroundColor: 'bodyGray.main',
              fontSize: '12px',
              border: '1px solid',
              borderColor: 'bodyGray.main',
              height: '30px',
              boxShadow: `
  inset 0 0 0.5px 1px hsla(0, 0%, 100%, 0.075),
  0 0 0 1px hsla(0, 0%, 0%, 0.05),
  0 0.3px 0.4px hsla(0, 0%, 0%, 0.02),
  0 0.9px 1.5px hsla(0, 0%, 0%, 0.045),
  0 3.5px 6px hsla(0, 0%, 0%, 0.09)`,
              backgroundColor: '#f9f9fe',
              // marginLeft: { xs: "0px", sm: "20px" },
              // marginBottom: { xs: "20px", sm: "0px" },
              // height: "30px",
              minWidth: { xs: '50px', sm: '64px' },
              cursor: 'pointer',
            }}
          >
            {loading ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              // <Link
              //   to={routeSelector(selectedTab)}
              //   style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}
              // >
              // </Link>
              <CloudUpload sx={{ color: '#ffa500', opacity: 1 }} onClick={handleLedgerExport} />
            )}
          </Button>
        </Tooltip>
      ) : isDashboard ? (
        <Tooltip title="Export Dashboard" placement="bottom">
          <Button
            disableRipple
            disableElevation
            variant="outlined"
            onClick={handleDashboardExport}
            sx={{
              color: 'primary.main',
              backgroundColor: 'bodyGray.main',
              fontSize: '12px',
              border: '1px solid',
              borderColor: 'bodyGray.main',
              height: '30px',
              boxShadow: `
    inset 0 0 0.5px 1px hsla(0, 0%, 100%, 0.075),
    0 0 0 1px hsla(0, 0%, 0%, 0.05),
    0 0.3px 0.4px hsla(0, 0%, 0%, 0.02),
    0 0.9px 1.5px hsla(0, 0%, 0%, 0.045),
    0 3.5px 6px hsla(0, 0%, 0%, 0.09)`,
              backgroundColor: '#f9f9fe',
              minWidth: { xs: '50px', sm: '64px' },
              cursor: 'pointer',
            }}
          >
            {loading ? <CircularProgress size={16} color="inherit" /> : <CloudUpload sx={{ color: '#ffa500', opacity: 1 }} />}
          </Button>
        </Tooltip>
      ) : (
        <Tooltip title="Export" placement="bottom">
          <Button
            disableRipple
            disableElevation
            variant="outlined"
            onClick={onExportClick}
            sx={{
              color: 'primary.main',
              backgroundColor: 'bodyGray.main',
              fontSize: '12px',
              border: '1px solid',
              borderColor: 'bodyGray.main',
              height: '30px',
              boxShadow: `
  inset 0 0 0.5px 1px hsla(0, 0%, 100%, 0.075),
  0 0 0 1px hsla(0, 0%, 0%, 0.05),
  0 0.3px 0.4px hsla(0, 0%, 0%, 0.02),
  0 0.9px 1.5px hsla(0, 0%, 0%, 0.045),
  0 3.5px 6px hsla(0, 0%, 0%, 0.09)`,
              backgroundColor: '#f9f9fe',
              minWidth: { xs: '50px', sm: '64px' },
              cursor: 'pointer',
            }}
          >
            {loading ? <CircularProgress size={16} color="inherit" /> : <CloudUpload sx={{ color: '#ffa500', opacity: 1 }} />}
          </Button>
        </Tooltip>
      )}
      <ExportModal {...exportModalProps} />
    </>
  );
}

export default memo(DbExportButton);
